import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import SvgIcon from "../../../components/svg-icon";
import stringHelper from "../../../helpers/string-helper";
import VaultDeposit from "./deposit";
import VaultWithdrawModal from "./withdraw";


const VaultModal = props => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const {authenticated} = useSelector(state => state.authenticationReducer)


    const {handleClose} = props
    const {user} = useSelector(state => state.authenticationReducer)
    const navigate = useNavigate()

    const handleNavigationSecurity = () => {
        handleClose()
        navigate(stringHelper.getLocalizedPath(currentLanguage, '/settings?tab=security'))
    }

    const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))
    const handleNetworkSettings = response => store.dispatch(AUTHENTICATION_ACTIONS.setNetworkSettings(response?.data || []))


    useEffect(() => {
        if (authenticated) {
            associateServices.getWallets({}).then(handleUserWallets)
            associateServices.getNetworkSettings({}).then(handleNetworkSettings)


            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('wallet-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'
            mdl.classList?.add('modal-fade')


            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')
            }
        }

    }, [authenticated])

    const [items] = useState([
        'deposit',
        'withdraw',
    ])

    const {modalTab} = useSelector(state => state.globalReducer)
    const [activeType, setActiveType] = useState('deposit')

    useEffect(() => {
        if (modalTab)
            setActiveType(modalTab)
    }, [modalTab])

    const [searchParams, setSearchParams] = useSearchParams()

    const getDynamicContent = () => {
        switch (activeType) {
            case 'deposit':
                return <VaultDeposit/>

            case 'withdraw':
                return <VaultWithdrawModal handleClose={handleClose}/>

            default:
                return null;
        }
    }


    const handleActiveType = type => {
        searchParams.set('modal', 'vault')
        searchParams.set('tab', type)
        setSearchParams(searchParams)
    }
    return (
        <div
            className="modal fade"
            id="wallet-modal"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <div className="d-flex align-items-center gap-2">
                                <SvgIcon id={'vault'}/>
                                <h6 className="modal__title">{t('modals.vault.title')}</h6>
                            </div>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <ul className="nav nav-tabs tabs-nav tabs-nav--modal">
                            {
                                items?.map(ii => (
                                    <li
                                        onClick={e => handleActiveType(ii)}
                                        className="nav-item" role="presentation"
                                        key={ii}
                                    >
                                        <button
                                            className={`tabs-nav__btn ${activeType === ii ? 'active' : ''}`}
                                            type="button"
                                        >

                                            {t(`modals.vault.${ii}`)}
                                        </button>
                                    </li>
                                ))
                            }
                        </ul>
                        <div className="tab-content">
                            <div
                                className="tab-pane fade show active"
                                role="tabpanel"
                            >
                                {
                                    getDynamicContent()
                                }

                                <div className="form__cellar">
                                    {
                                        !user?.authenticator_enabled &&
                                        <>
                                            <p>
                                                {t('modals.vault.2factor-desc')}
                                            </p>
                                            <button type="button"
                                                    onClick={handleNavigationSecurity}
                                            >
                                                {t('modals.vault.2factor-button')}
                                            </button>
                                        </>
                                    }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default VaultModal
